import script from "./SingleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleCard.vue?vue&type=script&setup=true&lang=ts"

import "./SingleCard.vue?vue&type=style&index=0&id=7ac0c3f3&lang=css"

const __exports__ = script;

export default __exports__